import { memo, useCallback } from 'react'

import { getLabelByExternalField } from 'clickNgo/entities/partner/libs/helpers'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { partnerEditorTranslation } from '../../translation'

import { IMenuLabelWithInfoProps } from './models'

import styles from './MenuLabelWithInfo.module.scss'

export const MenuLabelWithInfo = memo<IMenuLabelWithInfoProps>(
  ({ isInactive, title, status, modifiedValues = [] }) => {
    const tooltipContent = useCallback(
      () => (
        <>
          <div className={styles.tipTitle}>{status}:</div>{' '}
          <ul className={styles.tipList}>
            {modifiedValues?.map(getLabelByExternalField).map((label) => (
              <li key={label}>
                <Translation text={label as string} span />
              </li>
            ))}
          </ul>
        </>
      ),
      [modifiedValues, status]
    )

    if (status && !isInactive) {
      return (
        <div className={styles.container}>
          <Translation text={title} />
          <Tooltip tipContent={tooltipContent}>
            <span className={styles.status}>
              <Translation text={partnerEditorTranslation.other.menuStatus} />{' '}
              <span className={styles.statusText}>{status}</span>
            </span>
          </Tooltip>
        </div>
      )
    }

    return <Translation text={title} />
  }
)
